import { z } from 'zod'
import { CustomerChatThreadStatus } from '../constants/customerChatThread'
import { CustomerChatMessageType } from '../constants/customerChatMessage'
import { dbEntitySchema } from './system'

export const customerChatThreadSchema = dbEntitySchema.extend({
  organization: z.string(),
  venue: z.string(),
  customer: z.string(),
  followers: z.array(z.string()),
  customerName: z.string().nullish(),
  customerEmail: z.string().nullish(),
  customerPhone: z.string().nullish(),
  status: z.nativeEnum(CustomerChatThreadStatus),
  needsResponse: z.boolean().nullish(),
  openedOn: z.date().nullish(),
  openedByOrganizationMember: z.string().nullish(),
  closedOn: z.date().nullish(),
  closedByOrganizationMember: z.string().nullish(),
  lastMessageReceivedText: z.string().nullish(),
  lastMessageReceivedDate: z.date().nullish(),
  lastMessageReceivedType: z
    .nativeEnum(CustomerChatMessageType)
    .optional()
    .nullable(),
})

export const customerChatThreadCreateOrUpdateArgsSchema =
  customerChatThreadSchema
    .omit({
      id: true,
      _id: true,
      deleted: true,
      created: true,
      modified: true,
      organization: true,
      venue: true,
      customer: true,
      followers: true,
      customerName: true,
      customerEmail: true,
      customerPhone: true,
      // needsResponse: true,
      openedOn: true,
      openedByOrganizationMember: true,
      closedOn: true,
      closedByOrganizationMember: true,
      // lastMessageReceivedText: true,
      // lastMessageReceivedDate: true,
      // lastMessageReceivedType: true,
    })
    .partial()
    .extend({
      organizationId: z.string(),
      venueId: z.string(),
      customerId: z.string(),
      sendPubSubEvents: z.boolean().nullish(),
    })

export const customerChatThreadListArgsSchema = z.object({
  organizationId: z.string().nullish(),
  venueId: z.string().nullish(),
  customerId: z.string().nullish(),
  status: z
    .nativeEnum(CustomerChatThreadStatus)
    .or(z.array(z.nativeEnum(CustomerChatThreadStatus)))
    .nullish(),
  needsResponse: z.boolean().nullish(),
  openedOn: z.date().nullish(),
  openedByOrganizationMember: z.string().nullish(),
  closedOn: z.date().nullish(),
  closedByOrganizationMember: z.string().nullish(),
  search: z.string().nullish(),
})
